import { AdminLayout } from './layout/admin-layout/admin-layout';
import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  // 1. Public / Authentication Routes
  { 
    path: 'auth/login', 
    loadComponent: () => import('./pages/auth/login/login').then((m) => m.Login) 
  },

  {
	path: 'auth/verify-otp',
	loadComponent: () => import('./pages/auth/verify-otp/verify-otp').then((m)=>m.VerifyOtp)
  },
  {
    path: '',
    component: AdminLayout,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { 
        path: 'dashboard', 
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard) 
      },
      { 
        path: 'approver', 
        loadComponent: () => import('./pages/approvers/approvers').then((m) => m.Approvers) 
      },
      { 
        path: 'sub-tenants', 
        loadComponent: () => import('./pages/sub-tenants/sub-tenants').then((m) => m.SubTenants) 
      },
    ],
  },

  // 3. Fallbacks and Global Redirects
  { path: '**', redirectTo: 'dashboard' },
];
